import "./i18n";
import('./bootstrap');

export {}; // Add this line
